import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ACTIVE_TOKENS_REDUCER_KEY } from '../reducers/tokens.reducer';

import type { ActiveTokensInitialState } from '../states/tokens.state';

export const activeTokensState = createFeatureSelector<ActiveTokensInitialState>(ACTIVE_TOKENS_REDUCER_KEY);
/**
 * Invalidate Tokens
 */
export const InvalidateTokensSuccessState = createSelector(activeTokensState, state => state?.invalidate.success);
export const InvalidateTokensFailedState = createSelector(activeTokensState, state => state?.invalidate.error);
